export default __webpack_public_path__ + "static/media/messenger.19626b2f.svg";